export default __webpack_public_path__ + "static/dairy-free-taste-2-mobile-e15909fb6ae7fc08e7fa1b17eff63b5c.png";